import { RedirectMethod, createFormHTML } from '@endeavour/payment-integration';

async function processPayment(baseConfig, requestConfig) {
    const url = `${baseConfig.apiUrl}/api/${requestConfig.method}/${requestConfig.type}/process`;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            sessionId: requestConfig.sessionId,
            userId: requestConfig.userProfileId,
            merchantId: baseConfig.merchantId,
            accountId: requestConfig.accountId,
            attributes: {},
            ...requestConfig.formData,
        }),
    };
    const req = await fetch(url, requestOptions);
    const result = await req.json();
    const output = result.redirectOutput;
    if (output &&
        output.method.toLowerCase() === RedirectMethod.POST.toLowerCase() &&
        !output.html) {
        output.html = createFormHTML(output);
    }
    return result;
}

export { processPayment };
